// tslint:disable:member-ordering
import { VasState } from "../../store/store-type";
import { createSelector } from "reselect";

export class ConfigQueries {
    static _state = (state: VasState) => state.config;
    static getLastSyncDownDate = createSelector(ConfigQueries._state, state => state.lastSyncDown);
    static getAuthToken = createSelector(ConfigQueries._state, state => state.authToken);
    static getRefreshToken = createSelector(ConfigQueries._state, state => state.refreshToken);
    static getRestHost = createSelector(ConfigQueries._state, state => state.restHost);
    static getRestEndpoint = createSelector(ConfigQueries._state, state => state.restEndpoint);
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/config/config.queries.ts